<template>
  <page-layout title="电子对账单" class="p-Statement">
    <header class="c-tradingcenter-search-header clearfix">
      <div class="c-tradingcenter-search-header-fl">
        <znl-input
          :border="true"
          v-model="dataTime"
          :height="30"
          date-type="daterange"
          form-type="datepicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="true"
          class="header-marginleft"
          @change="dataTimeChange"
          ref="dateinput"
          title="日期："
          title-width="40px"
        ></znl-input>
        <znl-input
          width="150px"
          :height="30"
          :border="true"
          ref="input1"
          class="header-marginleft"
          :clearable="true"
          title="是否含税："
          title-width="60px"
          v-model="searchParams.IncludeTax"
          form-type="select"
          :select-options="selectOptionsTaxRate"
          @change="selectChange"
        ></znl-input>
        <znl-input
          width="150px"
          :height="30"
          :border="true"
          ref="input2"
          class="header-marginleft"
          :clearable="true"
          title="账单核对："
          title-width="60px"
          v-model="searchParams.IsAudited"
          form-type="select"
          :select-options="selectOptions"
          @change="selectChange"
        ></znl-input>
        <znl-input
          width="150px"
          :height="30"
          :border="true"
          ref="input3"
          class="header-marginleft"
          :clearable="true"
          title="收款状态："
          title-width="60px"
          v-model="searchParams.RecPayStatus"
          form-type="select"
          :select-options="selectOptionsRecPayStatus"
          @change="selectChange"
        ></znl-input>
        <znl-input
          width="150px"
          :height="30"
          :border="true"
          ref="input4"
          class="header-marginleft"
          :clearable="true"
          title="开票状态："
          title-width="60px"
          v-model="searchParams.InvoicedStatus"
          form-type="select"
          :select-options="selectOptionsInvoicedStatus"
          @change="selectChange"
        ></znl-input>
        <!-- <znl-button
          :width="60"
          :height="30"
          style-type="main"
          class="header-marginleft"
          @click="seachHandler"
        >
          <i class="iconfont icon-sousuo"></i>
          搜索
        </znl-button>-->
        <znl-button :width="60" :height="30" class="header-marginleft" @click="clearParams">
          <i class="iconfont icon-refresh"></i>
          重置
        </znl-button>
      </div>
    </header>
    <grid
      :columns="columns"
      :datas="datas"
      ref="grid"
      :total-count="totalCount"
      :page-size="pageSize"
      :page-index="pageIndex"
      :on-page-changed="onBindData"
      domLayout="autoHeight"
    ></grid>

    <StatementDetails
      :visible.sync="shiowStatementDetails"
      :ssguid="ssguid"
      :isaudited="isaudited"
      :includeTax="includeTax"
      :onBindData="onBindData"
    ></StatementDetails>
    <div style="display:none">
      <div class="images" v-viewer="{movable: false}">
        <img v-for="(src,index) in BankReceipt" :src="src" :key="index">
      </div>
    </div>
  </page-layout>
</template>
<script>
import PageLayout from '../PageLayout';
import { Columns } from './column';
import TradingStore from '../../store';
import StatementDetails from './StatementDetails';
import apis from '../../api';
import { httpPost } from '../../assets/scripts/http';
import { CONFIG } from '../../assets/scripts/config';
import Vue from 'vue';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { setTimeout } from 'timers';
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
export default {
  name: 'Statement',

  components: { PageLayout, StatementDetails },

  data () {
    return {
      store: TradingStore,
      columns: [],
      datas: [],
      totalCount: 0,
      pageSize: 20,
      pageIndex: 1,
      shiowStatementDetails: false,
      ssguid: '',
      isaudited: false,
      includeTax: false,
      searchParams: {
        IsAudited: '',
        StatementDateStart: '',
        StatementDateEnd: '',
        SupplierName: '',
        IncludeTax: null,
        RecPayStatus: null,
        InvoicedStatus: null,
      },
      dataTime: ['', ''],
      selectOptions: [
        {
          key: true,
          value: '已核对'
        },
        {
          key: false,
          value: '未核对'
        }
      ],
      selectOptionsTaxRate: [
        {
          key: true,
          value: '含税'
        },
        {
          key: false,
          value: '不含税'
        }
      ],
      selectOptionsInvoicedStatus: [
        {
          key: 1,
          value: '未开'
        },
        {
          key: 2,
          value: '部分开'
        },
        {
          key: 3,
          value: '已全开'
        }
      ],
      selectOptionsRecPayStatus: [
        {
          key: 1,
          value: '未收'
        },
        {
          key: 2,
          value: '部分收'
        },
        {
          key: 3,
          value: '已全收'
        }
      ],
      BankReceipt: []
    };
  },

  methods: {
    selectChange (value) {
      this.$nextTick(function () {
        this.onBindData();
      })

    },
    dataTimeChange (value) {
      this.dataTime = value ? value : ['', ''];
      this.onBindData();
    },
    clearParams () {

      this.searchParams = {};
      this.$refs.input1.clear();
      this.$refs.input2.clear();
      this.$refs.input3.clear();
      this.$refs.input4.clear();
      this.dataTime = null;
      this.onBindData();
    },
    onBindData (PageIndex = 1) {
      this.searchParams.StatementDateStart = this.dataTime
        ? this.dataTime[0] || ''
        : '';
      this.searchParams.StatementDateEnd = this.dataTime
        ? this.dataTime[1] || ''
        : '';
      apis
        .getStatement({
          PageIndex,
          pageSize: this.pageSize,
          StatementType: 2,
          ...this.searchParams
        })
        .then(res => {
          if (res.Code === 0) {
            this.datas = res.Data.ResultList || [];
            this.$refs.grid.setRowData(this.datas);
          } else {
            this.$erroMess(res.Message);
          }
        });
    },
    columnInit () {
      const vm = this;
      const OperationColumn = Columns.find(item => item.field === 'Operation');
      if (OperationColumn) {
        OperationColumn.cellRendererFramework = 'GridRenderCellButtons';
        OperationColumn.cellRendererParams = {
          buttons: [
            {
              text: '查看详情',
              click (params) {
                vm.shiowStatementDetails = true;
                vm.ssguid = params.data.SSGUID;
                vm.isaudited = params.data.IsAudited;
                vm.includeTax = params.data.IncludeTax;
              }
            },
            {
              text: '下载',
              click (params) {
                httpPost(
                  'tradeCentre/GenerateStatementFile',
                  { StatementType: 2, SSGUID: params.data.SSGUID },
                  { baseURL: 'res' }
                ).then(data => {
                  if (data.Code === 0) {
                    const filepath = `${CONFIG.RES_URL}tradeCentre/DownloadStatementFile/${data.Data}`;
                    if (window && window.cefQuery) {
                      window.cefQuery({
                        request: 'downloadFile',
                        data: JSON.stringify({
                          FileName: data.Data + '.csv',
                          FileUrl: filepath,
                          Status: true
                        }),
                        onSuccess: res => {
                          vm.$succMess('导出成功');
                        },
                        onFailure (err) {
                          console.log('window.cefQuery-fail', err);
                        }
                      });
                    } else {
                      const name = data.Data;
                      const a = document.createElement('a');
                      a.setAttribute('href', filepath);
                      a.setAttribute('download', name);
                      a.click();
                      vm.$succMess('下载成功');
                    }
                  } else {
                    vm.$erroMess(data.Message);
                  }
                });
              }
            }
          ]
        };
      }

      const BankReceiptColumn = Columns.find(item => item.field === 'BankReceipt');
      if (BankReceiptColumn) {
        BankReceiptColumn.cellRendererFramework = 'GridRenderCellButtons';
        BankReceiptColumn.cellRendererParams = {
          buttons: [
            {
              text: '查看',
              click (params) {
                if (params.value == null || params.value.length == 0) {
                  vm.$erroMess("该对账单没有上传水单");
                  return;
                }
                vm.BankReceipt = params.value
                setTimeout(() => {
                  const viewer = vm.$el.querySelector('.images').$viewer;
                  viewer.show();
                }, 200);
              }
            },
          ]
        };
      }
      this.$refs.grid.changeColumns(Columns);
    }
  },

  mounted () {
    this.columnInit();
    this.onBindData();
  }
};
</script>
<style lang="scss">
.p-Statement {
  .color-red {
    color: red;
  }
  .header-marginleft {
    margin-left: 10px;
  }
}
</style>
